import React,{ useState, useEffect, useContext }  from 'react'
import { Formik, Field, Form } from "formik";
import Modal from "react-modal";
import Cookies from "universal-cookie";
import classNames from "classnames";
import Dropzone from "react-dropzone";
import ItemImageComponent from "./components/ItemImageComponent"
import ItemHoldForm from "../events/holds/ItemHoldForm"
import ItemMessageComponent from "./components/ItemMessageComponent"
import { isJaguar, isSuperadmin, isClient } from "../utility/UserUtils"
import Button from '@mui/material/Button';
import UserContext from '@/context/UserContext';
import {fetchAPI} from '@/utility/NetworkUtils';
import Loading from '@/shared/Loading';
import InventoryChits from '@/items/components/InventoryChits';
import Stack from '@mui/material/Stack';
import { canUserAddItemToEvent, canUserAddItemToCart } from '@/utility/UserUtils'
import ItemUpdatedAtComponent from '@/items/components/ItemUpdatedAtComponent';
import { 
  renderButton,
  renderTextField,
  renderCancelButton,
  renderCheckField,
  renderRadioField,
  renderTextAreaField
} from '@/shared/FormUtils';
import AddToCartForm from './form/AddToCartForm';
import ItemHoldFormRevised from './form/ItemHoldFormRevised';
import ItemCost from './components/ItemCost';

const ItemCardQuickViewModal = (props) => {
  const { accessButton, onClose, disableOrder = false } = props;
  const { user } = useContext(UserContext);
  const [ open, setOpen ] = useState(false);
  const [ item, setItem ] = useState(null);
  const [ events, setEvents ] = useState([]);
  const [ page, setPage ] = useState(null);
  useEffect(() => {
    if(open) {
      fetchItem();
      setPage(null)
    }else {
      setItem(null)
    }
    
  }, [open]);
  
  const fetchItem = () => {
    fetchAPI(`/webapi/items/${props.item.id}`, (json) => {
      if (!json.error) {
        setItem(json.item)
      } else {
        console.log({
          errors: json.errors
        })
        alert(json.error)
      }
    });
  }

  const openModal = (e) => {
    e.stopPropagation();
    setOpen(true)
  }


  const closeModal = (
    changes=false
  ) => {
    console.log("[ItemCardQuickViewModal] closeModal", changes, onClose);
    setOpen(false)
    if(onClose) {
      onClose(changes);
    }
  }

  const renderAccessButton = () => {
    if (accessButton) {
      return (
        accessButton({onClick: openModal})
      )
    }
    return (
      <Button color="green" variant="contained" onClick={openModal}>
        Quick View
      </Button>
    )
  }

  const renderCustomFields = () => {
    let customFields = []
    if(isJaguar(user) && item.custom_fields) {
      //Check if custom fields is a string
      if(typeof item.custom_fields == "string") {
        try {
          customFields = JSON.parse(item.custom_fields).fields
        } catch (error) {
          console.log(error)
        }
      }else {
        customFields = item.custom_fields
      }
      if(customFields) {
        return customFields.map(field => (
          renderDetail(field.name, field.value)
        ));
      }
    }
  }

  const renderModal = () => {
    if(page == "add_to_cart") {
      return (
        <AddToCartForm item={item} onCancel={()=>setPage(null)} onSubmit={()=>closeModal(true)} />
      )
    }
    if(page == "add_to_event") {
      return (
        <ItemHoldFormRevised item={item} onCancel={()=>setPage(null)} onSubmit={()=>closeModal(true)} />
      )
    }

    const size = renderSize()
    const cartonSize = renderCartonSize()
    return (
      <div>
        <div class="text-emerald-900 text-[34px] font-medium font-['Roboto'] pb-4 font-weight-[400]">
          {item.name}
        </div>
        <ItemCost item={item} />
        
        {renderInventoryCounts()}
        <div className="row mt-[30px] sm:block md:flex lg:flex xl:flex">
          <div className="col-xs-12 col-sm-6">
            <ItemImageComponent item={item} />
          </div>
          <div className="flex flex-col flex-wrap pl-6">
            {renderDetail("Owner", item.renter?.name || "Jaguar Design Studio")}
            {renderDetail("Category / Subcategory", item.category ? `${item.category.group_name} / ${item.category.name}` : "Other")}
            {item.color && renderDetail("Color", item.color)}
            {item.apparel_gender && renderDetail("Apparel Gender", item.apparel_gender)}
            {item.apparel_size && renderDetail("Apparel Size", item.apparel_size)}
            {size && renderDetail("Size", size)}
            {renderCustomFields()}
            {isJaguar(user) && item.internal_notes && renderDetail("Internal Notes", (item.internal_notes).split("\n").map((x,i) => <div key={i}>{x}</div>))}
            {isJaguar(user) && item.warehouse_location && renderDetail("Warehouse Location", item.warehouse_location)}
            {isJaguar(user) && (
              <ItemUpdatedAtComponent item={item} />
            )}
          </div>
        </div>
        {renderButtons()}
      </div>
    )
  }

  const renderInventoryCounts = () => {
    return (
      <div className="item-form-inventory-chit-container">
        <InventoryChits
          item={item}
        />
      </div>
    )
  }


  const renderSize = () => {
    const dimensions = [item.product_width, item.product_height, item.product_length].filter(x=>x).map(x=>parseFloat(x))
    if(dimensions.length > 0) {
      let value = "";
      if(item.size_type) {
        value = dimensions.map(x=>x+'ft.').join(" x ")
      }else {
        value = dimensions.map(x=>x+'"').join(" x ")
      }
      return value
    }
  }

  const renderCartonSize = () => {
    const dimensions = [item.carton_length, item.carton_width, item.carton_height].filter(x=>x).map(x=>parseFloat(x))
    if(dimensions.length > 0) {
      let value = "";
      value = dimensions.map(x=>x+'"').join(" x ")
      return value
    }
  }

  const renderDetail = (label, value) => {
    return (
      <div className="quickview-field">
        {label}: <span> {value} </span>
      </div>
    )
  }

  const renderButtons = () => {
    return (
      <Stack direction="row" spacing={2} justifyContent="flex-end" className="mt-4">

        {renderButton("View Full Details", ()=>{
          window.location.href = `/items/${item.id}`
        }, {color:"green"})}

        {canUserAddItemToCart(user, item) && !disableOrder &&
        renderButton("Add to Order", ()=>{
          setPage("add_to_cart")
        }, {color:"darkGreen"})}
        {canUserAddItemToEvent(user, item) &&
        renderButton("Add to Event", ()=>{
          setPage("add_to_event")
        }, {color:"burgandy"})}
               
      </Stack>
    )
  }


  return(
    <React.Fragment>
      {renderAccessButton()}
      {open ? (
        <Modal
            className="react-modal item-card-quick-view-modal"
            overlayClassName="react-modal-overlay"
            isOpen={open}
            onRequestClose={()=>closeModal()}
            contentLabel="Item Quickview"
          >
            {open && item ? (
              renderModal()
            ):(
              <Loading />
            )}
        </Modal>
      ):""}
    
    </React.Fragment>
  )
}

export default ItemCardQuickViewModal
